export default __webpack_public_path__ + "static/media/House.476e9214.png";